// Returns the current application year (calendar year).
export function getAppYear(): number {
  return new Date().getFullYear() + 1;
}
